import { userService } from '@/services'

let initialState = {
  creditBalance: null
}

export default {
  state: () => initialState,
  mutations: {
    SET_CREDIT_BALANCE(state, creditBalance) {
      state.creditBalance = creditBalance
    },
    RESET_CREDIT(state) {
      const s = initialState
      Object.keys(s).forEach(key => {
        state[key] = s[key]
      })
    }
  },
  actions: {
    async getCreditBalance({ dispatch }) {
      await userService
        .getCreditBalance()
        .then(async function(response) {
          await dispatch('setCreditBalance', response.balance || 0)
        })
        .catch(() => {})
    },
    setCreditBalance({ commit }, creditBalance) {
      commit('SET_CREDIT_BALANCE', creditBalance)
    },
    resetCredit({ commit }) {
      commit('RESET_CREDIT')
    }
  },
  getters: {}
}
